import { UPDATE_BACK_IN_STOCK_VARIANTS } from "../constants";

import { enableAlert } from "./enableAlert";
import { disableAlert } from "./disableAlert";

export const notificationChange =
  ({ variantId, isOptedIn, isPriority }) =>
  async dispatch => {
    dispatch({
      type: UPDATE_BACK_IN_STOCK_VARIANTS,
      payload: {
        variantId,
        isOptedIn,
        isPriority
      }
    });

    dispatch(
      (isOptedIn ? disableAlert : enableAlert)({ variantId, isPriority })
    );
  };
